import { LittleJSEngine } from './engine';
import { SceneManager } from './game/scenes/sceneManager';
import { MenuScene } from './game/scenes/menuScene';
import { CombatScene } from './game/scenes/combatScene';
import { SCENES } from './game/constants';
import { AudioManager } from './audio/audioManager';
import { GameServices } from './game/services';
import { generateWombatSprites } from './assets/wombatSprites';
import { RankingService } from './game/ranking/rankingService';

const canvas = document.createElement('canvas');
canvas.id = 'littlejs-canvas';
document.getElementById('app')?.appendChild(canvas);

const muteButton = document.createElement('button');
muteButton.textContent = 'Audio: OFF';
muteButton.type = 'button';
muteButton.style.position = 'absolute';
muteButton.style.top = '12px';
muteButton.style.right = '12px';
muteButton.style.padding = '6px 10px';
muteButton.style.fontFamily = '"Press Start 2P", monospace';
muteButton.style.fontSize = '9px';
muteButton.style.background = '#1f3b2c';
muteButton.style.color = '#c8ffe2';
muteButton.style.border = '1px solid #4f8f6a';
muteButton.style.borderRadius = '4px';
muteButton.style.cursor = 'pointer';
muteButton.style.zIndex = '10';
document.body.appendChild(muteButton);

const rankingService = new RankingService();
void rankingService.refreshEntries();

const loadingContext = canvas.getContext('2d');
if (loadingContext) {
  loadingContext.fillStyle = '#102318';
  loadingContext.fillRect(0, 0, canvas.width || 320, canvas.height || 180);
  loadingContext.fillStyle = '#c8ffe2';
  loadingContext.font = '16px "Press Start 2P", monospace';
  loadingContext.fillText('Ładowanie spriteów...', 20, 40);
}

let audioRef: AudioManager | undefined;
const updateMuteLabel = (): void => {
  muteButton.textContent = audioRef?.isMuted() ? 'Audio: OFF' : 'Audio: ON';
};

async function bootstrap(): Promise<LittleJSEngine> {
  const audio = new AudioManager();
  audioRef = audio;
  updateMuteLabel();
  const sprites = generateWombatSprites();
  const services: GameServices = { audio, sprites, ranking: rankingService };

  const engine = new LittleJSEngine(canvas, {
    width: 320,
    height: 180,
    pixelScale: 3,
    background: '#102318',
  });
  engine.setCanvasPixelated(true);
  engine.setTilesPixelated(true);
  engine.setSharpness(1.08);

  const sceneManager = new SceneManager();
  const menuScene = new MenuScene(sceneManager, services);
  const combatScene = new CombatScene(sceneManager, services);

  sceneManager.register(menuScene);
  sceneManager.register(combatScene);
  sceneManager.start(SCENES.MENU);

  engine.setScene(sceneManager);
  engine.start();

  const unlock = (): void => {
    audio.unlock();
  };

  window.addEventListener('pointerdown', unlock, { once: true });
  window.addEventListener('keydown', unlock, { once: true });
  window.addEventListener('blur', () => audio.stopBackground());

  muteButton.addEventListener('click', () => {
    if (!audioRef) {
      return;
    }
    audioRef.toggleMute();
    updateMuteLabel();
  });

  return engine;
}

const enginePromise = bootstrap();

export default enginePromise;
